import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg width="100%" height="18px" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect id="row1-name" x="0" y="0" width="40%" height="100%" rx="2" />
        </g>
    </svg>
);

const FieldLoadingIndicator = (props) => (
    <RootWrapper {...props}>
        <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default FieldLoadingIndicator;
